import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ClientAccount, LanguagePair } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = LanguagePair[];

export const useLanguagesPairs = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query languagePairs {
      clientAccount {
        languagePairs {
          description
          sourceLanguageCode
          targetLanguageCode
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['useLanguagesPairs'],
    queryFn: async () => {
      const response = (await client.request({
        data: {
          gql: graphql
        }
      })) as unknown as Pick<ClientAccount, 'languagePairs'>;

      return response?.languagePairs;
    }
  });
};
